<script>
import LadCardBase from './base'

export default {
  name: 'LadCardExperience',
  extends: LadCardBase,
}
</script>

<style lang="scss">
.container--box-card {
  &.container--box-card-experience,
  &.container--box-card-package {
    position: relative; /** se define asi para que el descuento este en la derecha superior */

    .wrapper-experience-name,
    .wrapper-package-name {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 0 10px;
      z-index: 10;

      .title {
        color: white;
        text-shadow: 2px 2px 15px #464646;
      }
    }
    .wrapper-card-description {
      position: initial;
      padding: 10px;

      .price-content {
        margin-left: initial;
      }

      .discount-value {
        display: none;
        &.discount-promo {
          display: inline-block;
          position: absolute;
          border-radius: 0;
          width: 0;
          height: 0;
          border-color: transparent #d62007 transparent transparent;
          border-style: solid;
          border-width: 0 45px 45px 0;
          right: 0;
          top: 0;
          padding: 0;
          margin: 0;
          background-color: transparent;

          & > span {
            text-align: center;
            top: 9px;
            left: 7px;
            position: relative;
            width: 45px;
            color: #fff;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            font-size: 12px;

            span {
              display: none;
            }
          }
        }
      }

      h5 {
        margin-top: 5px;
      }
    }

    .wrapper-card-media {
      .wrapper-media-top {
        height: 270px;
      }
    }

    .wrapper-price {
      margin: 0 -10px -10px;
      padding: 10px;

      & > span {
        &:first-child {
          text-transform: capitalize;
          font-size: 0.8em;
        }
      }

      &.show-more {
        margin-top: 20px;
      }
    }

    .wrapper--price-bottom {
      padding: 0;

      &.per-person {
        display: none;
      }
    }

    .wrapper-reviews {
      margin: 5px 0;

      .el-rate__icon {
        margin-right: 0;
      }

      .without-reviews {
        font-size: 0.8em;
        line-height: 20px;
      }
    }

    .days-starting-point {
      display: block;
      color: #646c77;
      font-size: 0.9em;
      // min-height: 32px;
    }

    .price-content {
      grid-template-columns: auto auto auto 1fr;

      .price--price {
        font-size: 1.5em;
        font-weight: 400;
      }

      &--extra,
      &--center {
        text-transform: lowercase;
      }

      &--left,
      &--right {
        height: auto;
      }

      &--extra {
        padding: 0 5px;
      }

      .price--symbol {
        & + span {
          display: none;
        }
      }
    }
  }
}
</style>
